<template>
  <Layout>
    <b-overlay :show="getIsLoading" spinner-variant="success" variant="light" opacity="0.5">
      <template #overlay>
        <b-spinner class="spiner-width" label="Large Spinner" variant="success"></b-spinner>
      </template>
      <div><a :href="'/proposals'" size="lg" class="color pointer"><i
            class="mdi mdi-arrow-left color me-2 "></i>Retour</a>
        <span class="float-end">Dossiers / #{{ this.$route.params.id }} / Proposition</span>
      </div>
      <div class="row mb-2 mt-3">
        <h1>#{{ this.$route.params.id }} - Demande de financement</h1>
      </div>
      <div class="card">
        <div class="card-body">
          <form class="outer-repeater">
            <div data-repeater-list="outer-group" class="outer">
              <div data-repeater-item class="outer">
                <div class="form-group row mb-4">
                  <h5 class="color-dark">Editer proposition</h5>
                  <label for="name" class="col-form-label">Nom de la proposition</label>
                  <div v-if="getDetails">
                    <input id="name" name="name" v-model="proposal.name" type="text" class="form-control"
                      placeholder="Entrez le nom du proposition" :class="{
                        'is-invalid': submitted && $v.proposal.name.$error,
                      }" />
                    <div v-if="submitted && $v.proposal.name.$error" class="invalid-feedback">
                      <span v-if="!$v.proposal.name.required">Ce champ est obligatoire.</span>
                    </div>
                  </div>
                </div>
                <b-form-group class="mb-3" id="date" label="Valide jusqu’au" label-for="date">
                  <b-input id="date" v-model="proposal.date" type="date" :min="nowDate" max="2023-04-01"
                    onkeydown="return false" :class="{
                      'is-invalid': submitted && $v.proposal.date.$error,
                    }" />
                  <div v-if="submitted && $v.proposal.date.$error" class="invalid-feedback">
                    <span v-if="!$v.proposal.date.required">Ce champ est obligatoire.</span>
                  </div>
                </b-form-group>
                <div class="form-group row mb-4">
                  <label class="col-form-label">Détail de l’offre</label>
                  <div class="">
                    <textarea id="desc" name="desc" v-model="proposal.description" class="form-control" rows="4"
                      placeholder="Ajouter une description ici" :class="{
                        'is-invalid': submitted && $v.proposal.description.$error,
                      }" />
                    <div v-if="submitted && $v.proposal.description.$error" class="invalid-feedback">
                      <span v-if="!$v.proposal.description.required">Ce champ est obligatoire.</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="mt-3">
                    <label for="formFile" class="form-label">Fichier 1 :</label>
                    <input class="form-control" type="file" ref="file1"
                      accept="image/*, .pdf, .doc, .docx, .xls, .zip, .rar" @change="onFileChange($event, 1)" />
                  </div>
                </div>
                <div class="row">
                  <div class="mt-3">
                    <label for="formFile1" class="form-label">Fichier 2 :</label>
                    <input class="form-control" ref="file2" type="file" id="formFile1"
                      accept="image/*, .pdf, .doc, .docx, .xls, .zip, .rar" @change="onFileChange($event, 2)" />
                  </div>
                </div>
                <div class="row">
                  <div class="mt-3">
                    <label for="fileId" class="form-label">Fichier 3 :</label>
                    <input class="form-control" ref="file3" type="file" id="fileId"
                      accept="image/*, .pdf, .doc, .docx, .xls, .zip, .rar" @change="onFileChange($event, 3)" />
                  </div>
                </div>
                <div class="form-group row mt-5 d-flex col-12">
                  <div class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1 mt-2 d-flex margin">
                    <div class="mr-auto">
                      <b-button type="submit" variant="secondary" href="/proposals"
                        class="btn-block py-2 px-4 ml-4">Annuler
                      </b-button>
                    </div>
                  </div>
                  <div class="col-6 col-sm-1 col-md-2 col-lg-2 col-xl-3 mt-2 d-flex">
                    <div>
                      <b-button type="submit" variant="magenta" class="btn-block py-2 px-4 ml-4"
                        @click="editProposal($event, 1)">Enregistrer
                      </b-button>
                    </div>
                  </div>
                  <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 d-flex justify-content-end mt-2 margin-env">
                    <div>
                      <b-button type="submit" variant="magenta" class="btn-block py-2 px-4 ml-4"
                        @click="editProposal($event, 2)">Envoyer
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </b-overlay>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import api from "../../../services/axiosHeader.js";
import { uploadFile } from "../../../../api/entryPoint";


export default {
  props: {},
  page: {
    title: "Proposition",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    return {
      submitted: false,
      proposal: {
        montant: "",
        name: "",
        description: "",
        date: "",
        id: "",
        nowDate: "",
        request: "",
        draft: "",
        file1: "",
        file2: "",
        file3: "",
        statut: "",
        message: "",
      },
    };
  },
  validations: {
    proposal: {
      name: {
        required,
      },
      description: {
        required,
      },
      date: {
        required,
      },
    },
  },
  created() {
    this.$store.dispatch("proposals/proposalDetails", this.$route.params.id);
    this.nowDate = new Date().toLocaleDateString('en-CA')
  },
  methods: {
    editProposal(e, id) {
      e.preventDefault();
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (!this.$v.$invalid) {
        (id === 1) ? this.proposal.draft = true : this.proposal.draft = false;
        this.submitData(id);
      } else {
        return;
      }
    },
    submitData(id) {
      this.proposal.id = this.$route.params.id;
      this.proposal.request = this.getDetails.request.id;
      (id === 1) ? this.proposal.message = 'modifier' : this.proposal.message = 'ajouter';
      this.$store.dispatch("proposals/updateProposal", this.proposal);
    },
    /* Alerts */
    showAlert(data) {
      Swal.fire({
        icon: data.icon,
        title: data.title,
        text: data.text,
        confirmButtonColor: "#b1215c",
        showCancelButton: data.showCancelButton,
        confirmButtonText: data.confirmButtonText
          ? data.confirmButtonText
          : "OK",
        cancelButtonText: data.cancelButtonText,
      }).then((res) => {
        if (data.confirmType) {
          if (data.confirmType.type === "Modifier") {
            if (res.isConfirmed)
              this.windows.location.href = "/proposals"
          }
        }
      });
    },
    async matchData(data) {
      this.proposal.name = data.poNumber;
      this.proposal.description = data.s_quote_detail;
      this.proposal.id = this.$route.params.id;
      this.proposal.date = this.dateFormat(data.validUntil);
      if (data.s_quote_att_1) {
        this.$refs.file1.files = this.prepareFormatFile(data["s_quote_att_1"]);
        this.proposal.file1 = data["s_quote_att_1"].id;
      }
      if (data.s_quote_att_2) {
        this.$refs.file2.files = this.prepareFormatFile(data["s_quote_att_2"]);
        this.proposal.file2 = data["s_quote_att_2"].id;
      }
      if (data.s_quote_att_3) {
        this.$refs.file3.files = this.prepareFormatFile(data["s_quote_att_3"]);
        this.proposal.file3 = data["s_quote_att_3"].id;
      }
    },
    prepareFormatFile(fileData) {
      var file = new File(['content'], fileData.originalFilename, { type: fileData.mimeType });
      return this.FileListItems([file]);
    },
    FileListItems(files) {
      var b = new ClipboardEvent("").clipboardData || new DataTransfer()
      for (var i = 0, len = files.length; i < len; i++) b.items.add(files[i])
      return b.files
    },
    onFileChange(e, id) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.createImage(files[0], id);
    },
    createImage(file, id) {
      let data = new FormData();
      switch (id) {
        case 1:
          data.append('s_quote_att_1', file);
          break;
        case 2:
          data.append('s_quote_att_2', file);
          break;
        case 3:
          data.append('s_quote_att_3', file);
          break;
      }
      api.post(uploadFile, data)
        .then(
          response => {
            switch (id) {
              case 1:
                this.proposal.file1 = response;
                break;
              case 2:
                this.proposal.file2 = response;
                break;
              case 3:
                this.proposal.file3 = response;
                break;
            }
          }
        )
    },
  },
  computed: {
    getDetails() {
      let data = this.$store.getters["proposals/getDetails"];
      if (data && data.id) {
        this.matchData(data);
      }
      return data;
    },
    getIsLoading() {
      return this.$store.getters["proposals/getIsLoading"];
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  text-align: left;
  font-size: 20px !important;
  line-height: 30px !important;
  letter-spacing: 0;
  color: #000000;
  font-weight: 500 !important;
}

h5 {
  letter-spacing: 0;
  color: #000000 !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  opacity: 1;
}

.color {
  color: #747C8D;
}

.input-container input {
  border: none;
  box-sizing: border-box;
  outline: 0;
  padding: 75rem;
  position: relative;
  width: 100%;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  background: transparent;
  color: transparent;
  cursor: pointer;
  position: absolute;
  width: 100%;
  height: 10%;
}

@media screen and(min-width: 1220px) and(max-width: 1620px) {
  .margin {
    margin-right: 40px !important;
  }

  .margin-env {
    margin-left: -40px !important;
  }
}

@media screen and(min-width: 0px) and(max-width: 520px) {
  .margin-env {
    margin-left: -40px !important;
  }
}

.spiner-width {
  width: 3rem;
  height: 3rem;
}
</style>